import { AbstractService } from 'src/services/AbstractService';
import { ServiceError } from 'src/lib/errors';

interface DocumentSourceResponse {
    metadata: {
        documentSources: {
            panels: Array<{
                // This is the identifier of the panel metadata, e.g. TEMPLATE_TOKEN
                source: string;
                // This is temlate token
                data: string;
            }>;
        }
    };
}

class DocumentSourceServiceApi extends AbstractService {
    public static async fetchDocumentSource(
        documentSourceUri: string,
        signal?: AbortSignal,
    ): Promise<DocumentSourceResponse> {
        try {
            const response = await fetch(documentSourceUri, { signal });

            if (!response.ok) {
                throw new Error(`HTTP ${response.status}: ${response.statusText}`);
            }

            const data = await response.json();

            return data as DocumentSourceResponse;
        } catch (e: unknown) {
            throw new ServiceError({
                ...(e as Error),
                message: 'Failed to fetch document source',
                info: (e as Error).message,
                url: documentSourceUri,
            });
        }
    }
}

export { DocumentSourceServiceApi as DocumentSourceService };
